import { FlexContainer } from '@/reports/shared/OverviewItems/components';
import { styled } from '@/theme/index';

export const PropertyValueMainContainer = styled(FlexContainer)(() => ({
  flexDirection: 'column',
  alignItems: 'center',
}));

export const PropertyValueVerticalContainer = styled(FlexContainer)(
  ({ theme }) => ({
    marginTop: theme.spacing(3),
    flexDirection: 'column',
    alignItems: 'center',
    width: '70%',
  })
);

export const PropertyValueSoldDataContainer = styled(FlexContainer)(() => ({
  flexDirection: 'row',
  width: '70%',
  justifyContent: 'space-around',
}));

export const PropertyValueTextContainer = styled(FlexContainer)(() => ({
  alignContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const HorizontalLine = styled('hr')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  margin: `${theme.spacing(2)} auto`,
}));

export const VerticalLine = styled('div')(({ theme }) => ({
  minWidth: theme.spacing(0.1),
  height: theme.spacing(3),
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  minHeight: theme.spacing(2.5),
  backgroundColor: theme.palette.divider,
}));

export const PropertyValueTitleContainer = styled(FlexContainer)(
  ({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.palette.secondary.main,
    width: '100%',
  })
);
